import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, Loader2, MailCheck } from "lucide-react";
import { NavBar } from "../components/NavBar";
import { forgotPassword } from "../lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setSubmitting(true);
    try {
      await forgotPassword(email.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <NavBar />
      <main className="container-nc" style={{ paddingTop: 36, paddingBottom: 90, maxWidth: 460 }}>
        <button className="btn-icon" onClick={() => navigate("/sign-in")} data-testid="forgot-close" style={{ marginBottom: 24 }}>
          <X size={18} />
        </button>
        <span className="chip chip-brand">Account recovery</span>
        <h1 style={{ fontSize: "clamp(1.9rem, 5vw, 2.5rem)", fontWeight: 600, letterSpacing: "-0.03em", lineHeight: 1.1, margin: "18px 0 10px" }}>
          Forgot your password?
        </h1>

        {sent ? (
          <div className="card card-pad fade-up" data-testid="forgot-sent" style={{ textAlign: "center" }}>
            <span style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--brand-tertiary)", display: "grid", placeItems: "center", margin: "0 auto 14px" }}>
              <MailCheck size={26} color="var(--brand)" />
            </span>
            <h3 style={{ margin: "0 0 8px", fontWeight: 600 }}>Check your inbox</h3>
            <p style={{ color: "var(--muted)", fontSize: 14, lineHeight: 1.6, margin: 0 }}>
              If an account exists for <b style={{ color: "var(--on-surface-2)" }}>{email}</b>, we've sent a link to reset your password. It expires in 1 hour.
            </p>
            <button className="btn btn-ghost btn-lg" style={{ marginTop: 20 }} onClick={() => navigate("/sign-in")} data-testid="forgot-back">
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <p style={{ color: "var(--muted)", fontSize: 15.5, lineHeight: 1.6, marginBottom: 24 }}>
              Enter your account email and we'll send you a secure link to set a new password.
            </p>
            <form onSubmit={submit} className="card card-pad" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label className="label">Email</label>
                <input className="input" type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" autoComplete="email" />
              </div>
              {error && <p style={{ color: "var(--brand)", fontSize: 13, margin: 0 }} data-testid="forgot-error">{error}</p>}
              <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={submitting} data-testid="forgot-submit">
                {submitting ? <Loader2 size={18} className="spin" /> : "Send reset link"}
              </button>
              <div style={{ textAlign: "center", fontSize: 13 }}>
                <span className="link" onClick={() => navigate("/sign-in")} data-testid="forgot-signin">Back to sign in</span>
              </div>
            </form>
          </>
        )}
      </main>
    </>
  );
}
